<div class="spinner margin-top-l">
  <ion-spinner name="circles"></ion-spinner>
  <div class="margin-left-s">loading</div>
</div>
